import { render, staticRenderFns } from "./kindChooseViewjpkc.vue?vue&type=template&id=900630ac&scoped=true"
import script from "./kindChooseViewjpkc.vue?vue&type=script&lang=js"
export * from "./kindChooseViewjpkc.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewjpkc.vue?vue&type=style&index=0&id=900630ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900630ac",
  null
  
)

export default component.exports